// Agent's weekly Mon-Fri activity status for the team lead guardrail (preview; the guardrail is off by default).
import React, { useEffect, useState } from 'react';
import { ref, onValue } from 'firebase/database';
import { database } from '../../firebaseConfig';
import { useAuth } from '../../context/AuthContext';
import { eligibility } from '../../shared/teamLeadGuardrail';

const ICON = { active: '✓', missed: '✕', today: '…', upcoming: '' };
const BG = { active: '#1a1a1a', missed: '#9b2c2c', today: '#f5efe1', upcoming: '#fff' };
const FG = { active: '#D4AF37', missed: '#fff', today: '#8C6D1F', upcoming: '#7f7f7f' };
const DAY = ['Mon', 'Tue', 'Wed', 'Thu', 'Fri'];

export function WeekRow({ week, label }) {
  return (
    <div style={{ marginBottom: 10 }}>
      <div style={{ fontSize: 12, fontWeight: 700, textTransform: 'uppercase', color: '#8C6D1F', marginBottom: 4 }}>{label} (week of {week.weekOf})</div>
      <div style={{ display: 'flex', gap: 6 }}>
        {week.days.map((d) => (
          <div key={d.key} title={`${d.key}: ${d.state}`} style={{ width: 44, textAlign: 'center', border: '1px solid #d8c9a8', borderRadius: 6, padding: '4px 0', background: BG[d.state], color: FG[d.state], fontSize: 13 }}>
            <div>{DAY[new Date(`${d.key}T12:00:00Z`).getUTCDay() - 1]}</div><div style={{ fontWeight: 700 }}>{ICON[d.state]}</div>
          </div>
        ))}
      </div>
    </div>
  );
}

export default function WeeklyActivityStatus() {
  const { user } = useAuth();
  const [activity, setActivity] = useState(null);
  useEffect(() => {
    if (!user?.uid) return undefined;
    return onValue(ref(database, `users/${user.uid}/activity`), (s) => setActivity(s.val() || {}));
  }, [user?.uid]);
  if (!activity) return null;
  const e = eligibility({ loginDays: activity.loginDays, leadWorkDays: activity.leadWorkDays });
  return (
    <div style={{ background: '#fbf7ee', border: '1px solid #e5d6b0', borderRadius: 8, padding: '12px 16px', margin: '8px 0 16px' }}>
      <div style={{ fontWeight: 700, fontSize: 16, marginBottom: 8 }}>Your weekly status</div>
      <WeekRow week={e.thisWeek} label="This week" />
      <WeekRow week={e.lastWeek} label="Last week" />
      <p style={{ fontSize: 14, margin: '6px 0 0', color: '#5b6270' }}>
        {!e.enabled ? 'Preview only: the daily activity rule is not turned on yet.' : e.eligible ? "You're eligible for team leads this week." : `Team leads are paused this week. They turn back on the week of ${e.resumesWeekOf} after a full Monday-Friday week.`}
      </p>
    </div>
  );
}
